import React from 'react';
import { IoClose } from 'react-icons/io5';
import { ActionIcon, Button, Modal, Text } from 'rizzui';

interface CommercialTransferModalProps {
    isOpen: boolean;
    onClose: () => void;
    onTransfer: () => void;
    onCancel: () => void;
    currentCommercialName?: string;
    newCommercialName?: string;
}

const CommercialTransferModal: React.FC<CommercialTransferModalProps> = ({
    isOpen,
    onClose,
    onTransfer,
    onCancel,
    currentCommercialName = 'comercial anterior',
    newCommercialName = 'nuevo comercial'
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="md"
            overlayClassName="backdrop-blur"
            containerClassName="!shadow-2xl"
            className="z-[999] [&_.pointer-events-none]:overflow-visible"
        >
            <div className="m-auto px-7 pt-6 pb-8">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center">
                            <svg className="w-4 h-4 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <Text className="text-lg font-semibold text-gray-900">
                            Cambio de Comercial Detectado
                        </Text>
                    </div>
                    <ActionIcon size="md" variant="text" onClick={onClose}>
                        <IoClose className="h-auto" strokeWidth={1.8} />
                    </ActionIcon>
                </div>

                {/* Content */}
                <div className="mb-6">
                    <Text className="text-gray-700 mb-4 leading-relaxed">
                        Se ha detectado un cambio en el comercial asignado a este contrato.
                    </Text>

                    <div className="bg-gray-50 rounded-lg p-4 mb-4">
                        <div className="space-y-2">
                            <div className="flex justify-between items-center">
                                <Text className="text-sm font-medium text-gray-600">Comercial anterior:</Text>
                                <Text className="text-sm text-gray-900 font-medium">{currentCommercialName}</Text>
                            </div>
                            <div className="flex justify-between items-center">
                                <Text className="text-sm font-medium text-gray-600">Nuevo comercial:</Text>
                                <Text className="text-sm text-gray-900 font-medium">{newCommercialName}</Text>
                            </div>
                        </div>
                    </div>

                    <Text className="text-gray-700 text-sm">
                        ¿Desea transferir los puntos del registro actual al nuevo comercial?
                    </Text>
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-2">
                    <Button
                        onClick={onCancel}
                        variant="outline"
                        className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={onTransfer}
                        className="flex-1 bg-primary-600 hover:bg-primary-700 text-white transition-colors"
                    >
                        Transferir Puntos
                    </Button>
                </div>

                {/* Info note */}
                <div className="mt-4 p-3 bg-primary-50 rounded-lg">
                    <Text className="text-xs text-primary-700">
                        <strong>Nota:</strong> Esta acción transferirá todos los puntos asociados al contrato actual al nuevo comercial asignado.
                    </Text>
                </div>
            </div>
        </Modal>
    );
};

export default CommercialTransferModal;